/**
 * Kreation Builder — "Deine eigene Frischekiste"
 * State management, category filtering, variant switching, qty, Cart API
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-kb-root]');
  if (!root) return;

  var products = JSON.parse(root.dataset.products || '[]');
  if (products.length === 0) return;

  // ── State ──
  var state = {
    items: [],        // { productId, variantIndex, qty }
    mode: 'otp',      // 'otp' | 'abo'
    planId: null,
    activeCategory: 'all'
  };

  // ── DOM refs ──
  var cards = root.querySelectorAll('.kb-card');
  var catButtons = root.querySelectorAll('[data-kb-cat]');
  var sidebar = root.querySelector('[data-kb-sidebar]');
  var itemsContainer = root.querySelector('[data-kb-items]');
  var emptyMsg = root.querySelector('[data-kb-empty]');
  var summaryEl = root.querySelector('[data-kb-summary]');
  var totalWeightEl = root.querySelector('[data-kb-total-weight]');
  var totalPriceEl = root.querySelector('[data-kb-total-price]');
  var otpTotalEl = root.querySelector('[data-kb-otp-total]');
  var aboTotalEl = root.querySelector('[data-kb-abo-total]');
  var otpOption = root.querySelector('[data-kb-option="otp"]');
  var aboOption = root.querySelector('[data-kb-option="abo"]');
  var aboInfoBox = root.querySelector('[data-kb-abo-info]');
  var freqContainer = root.querySelector('[data-kb-frequencies]');
  var ctaBtn = root.querySelector('[data-kb-cta]');
  var ctaText = root.querySelector('[data-kb-cta-text]');
  var mobileBar = document.querySelector('[data-kb-mobile-bar]');
  var mobileCount = document.querySelector('[data-kb-mobile-count]');
  var mobilePrice = document.querySelector('[data-kb-mobile-price]');
  var mobileOpenBtn = document.querySelector('[data-kb-mobile-open]');
  var drawerOverlay = document.querySelector('[data-kb-drawer-overlay]');

  // ── Init selling plans from first product that has them ──
  var sellingPlans = [];
  for (var i = 0; i < products.length; i++) {
    if (products[i].selling_plans.length > 0) {
      sellingPlans = products[i].selling_plans;
      state.planId = sellingPlans[0].id;
      break;
    }
  }

  // Render frequency dropdown (matches product-page PCS card pattern)
  if (freqContainer && sellingPlans.length > 0) {
    var freqSelect = document.createElement('select');
    freqSelect.setAttribute('aria-label', 'Lieferintervall');
    freqSelect.dataset.kbFreqSelect = '';

    sellingPlans.forEach(function (plan, idx) {
      var opt = document.createElement('option');
      opt.value = plan.id;
      opt.textContent = simplifyFrequency(plan.name);
      if (idx === 0) opt.selected = true;
      freqSelect.appendChild(opt);
    });

    freqSelect.addEventListener('change', function () {
      state.planId = parseInt(freqSelect.value, 10);
      updateSidebar();
    });

    freqContainer.appendChild(freqSelect);
  }

  // ── Category filtering ──
  catButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cat = btn.dataset.kbCat;
      state.activeCategory = cat;
      catButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      filterCards();
    });
  });

  function filterCards() {
    cards.forEach(function (card) {
      if (state.activeCategory === 'all') {
        card.classList.remove('is-hidden');
        return;
      }
      var tags = (card.dataset.kbTags || '').toLowerCase().split(',');
      var match = tags.some(function (t) { return t.trim() === state.activeCategory.toLowerCase(); });
      card.classList.toggle('is-hidden', !match);
    });
  }

  // ── Card interactions ──
  cards.forEach(function (card) {
    var productId = parseInt(card.dataset.kbProductId, 10);
    var product = findProduct(productId);
    if (!product) return;

    var pills = card.querySelectorAll('[data-kb-variant-idx]');
    var qtyEl = card.querySelector('[data-kb-qty]');
    var priceEl = card.querySelector('[data-kb-price]');
    var minusBtn = card.querySelector('[data-kb-minus]');
    var plusBtn = card.querySelector('[data-kb-plus]');
    var currentVariantIdx = 0;

    // Store current variant index on card for access from plus handler
    card._kbVariantIdx = 0;

    // Disable unavailable variant pills
    pills.forEach(function (pill, idx) {
      if (product.variants[idx] && !product.variants[idx].available) {
        pill.disabled = true;
        pill.style.opacity = '0.4';
        pill.style.cursor = 'not-allowed';
      }
    });

    // Variant pill switching
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var idx = parseInt(pill.dataset.kbVariantIdx, 10);
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        card._kbVariantIdx = idx;

        // Update displayed price (current + compare-at strikethrough)
        var variant = product.variants[idx];
        if (variant) {
          updateCardPrice(priceEl, variant);
        }

        // Update state if item already in selection
        var existing = findItem(productId);
        if (existing) {
          existing.variantIndex = idx;
          updateSidebar();
        }
      });
    });

    if (!minusBtn || !plusBtn || !qtyEl) return;

    // Qty minus
    minusBtn.addEventListener('click', function () {
      var existing = findItem(productId);
      if (!existing) return;
      existing.qty -= 1;
      if (existing.qty <= 0) {
        removeItem(productId);
        qtyEl.textContent = '0';
      } else {
        qtyEl.textContent = existing.qty;
      }
      updateSidebar();
    });

    // Qty plus
    plusBtn.addEventListener('click', function () {
      var varIdx = card._kbVariantIdx;
      var variant = product.variants[varIdx];
      if (!variant || !variant.available) return;

      var existing = findItem(productId);
      if (existing) {
        existing.qty += 1;
        existing.variantIndex = varIdx;
        qtyEl.textContent = existing.qty;
      } else {
        state.items.push({
          productId: productId,
          variantIndex: varIdx,
          qty: 1
        });
        qtyEl.textContent = '1';
      }
      updateSidebar();
    });
  });

  // ── Einzel / Abo toggle ──
  if (otpOption) {
    otpOption.addEventListener('click', function () {
      state.mode = 'otp';
      otpOption.classList.add('is-active');
      aboOption.classList.remove('is-active');
      // Abo-Info-Box bleibt immer sichtbar (Design-Vorgabe)
      updateCta();
      updateSidebar();
    });
  }
  if (aboOption) {
    aboOption.addEventListener('click', function (e) {
      if (e.target.closest('[data-kb-frequencies]')) return;
      state.mode = 'abo';
      aboOption.classList.add('is-active');
      otpOption.classList.remove('is-active');
      // Abo-Info-Box bleibt immer sichtbar (Design-Vorgabe)
      updateCta();
      updateSidebar();
    });
  }

  // ── CTA click → add to cart ──
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      if (ctaBtn.disabled || state.items.length === 0) return;

      var items = [];
      state.items.forEach(function (item) {
        var product = findProduct(item.productId);
        if (!product) return;
        var variant = product.variants[item.variantIndex];
        if (!variant || !variant.available) return;

        var entry = { id: variant.id, quantity: item.qty };
        if (state.mode === 'abo' && state.planId) {
          entry.selling_plan = state.planId;
        }
        items.push(entry);
      });

      if (items.length === 0) return;

      ctaBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          showCtaFeedback('success', '\u2713 Hinzugefügt');
          updateCartCount();
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        })
        .catch(function () {
          showCtaFeedback('error', 'Fehler \u2014 erneut versuchen');
        });
    });
  }

  // ── Mobile drawer ──
  if (mobileOpenBtn) {
    mobileOpenBtn.addEventListener('click', function () {
      sidebar.classList.add('is-open');
      drawerOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    });
  }
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', function () {
      closeMobileDrawer();
    });
  }

  function closeMobileDrawer() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar && sidebar.classList.contains('is-open')) {
      closeMobileDrawer();
    }
  });

  // ── Sidebar rendering ──
  function updateSidebar() {
    if (!itemsContainer || !emptyMsg || !summaryEl) return;
    // IMMER alte Item-Rows entfernen (vor dem early-return!)
    var existingItems = itemsContainer.querySelectorAll('.kb-item');
    existingItems.forEach(function (el) { el.remove(); });

    // Summary bleibt immer sichtbar
    summaryEl.style.display = '';

    if (state.items.length === 0) {
      emptyMsg.style.display = '';
      if (mobileBar) mobileBar.style.display = 'none';
      ctaBtn.disabled = true;
    } else {
      emptyMsg.style.display = 'none';
      ctaBtn.disabled = false;
    }

    // Build items using safe DOM methods
    var totalWeight = 0;
    var totalOtp = 0;
    var totalAbo = 0;

    state.items.forEach(function (item) {
      var product = findProduct(item.productId);
      if (!product) return;
      var variant = product.variants[item.variantIndex];
      if (!variant) return;

      var linePrice = variant.price * item.qty;
      totalOtp += linePrice;

      // Calculate abo price
      var aboUnitPrice = variant.price;
      if (state.planId && variant.abo_prices) {
        for (var j = 0; j < variant.abo_prices.length; j++) {
          if (variant.abo_prices[j].plan_id === state.planId) {
            aboUnitPrice = variant.abo_prices[j].price;
            break;
          }
        }
      }
      totalAbo += aboUnitPrice * item.qty;

      // Weight
      if (variant.weight) {
        totalWeight += variant.weight * item.qty;
      }

      var variantLabel = variant.title !== 'Default Title' ? variant.title : '';

      // Create item row via DOM
      var row = document.createElement('div');
      row.className = 'kb-item';

      var info = document.createElement('div');
      info.className = 'kb-item__info';

      var nameSpan = document.createElement('span');
      nameSpan.className = 'kb-item__name';
      nameSpan.textContent = product.title;
      info.appendChild(nameSpan);

      var detailSpan = document.createElement('span');
      detailSpan.className = 'kb-item__detail';
      detailSpan.textContent = item.qty + '\u00D7 ' + variantLabel;
      info.appendChild(detailSpan);

      row.appendChild(info);

      var priceSpan = document.createElement('span');
      priceSpan.className = 'kb-item__price';
      priceSpan.textContent = formatMoney(linePrice);
      row.appendChild(priceSpan);

      var removeBtn = document.createElement('button');
      removeBtn.className = 'kb-item__remove';
      removeBtn.type = 'button';
      removeBtn.setAttribute('aria-label', 'Entfernen');
      removeBtn.textContent = '\u00D7';
      removeBtn.addEventListener('click', function () {
        removeItem(item.productId);
        // Reset qty display on card
        var card = root.querySelector('[data-kb-product-id="' + item.productId + '"]');
        if (card) {
          var qtyDisplay = card.querySelector('[data-kb-qty]');
          if (qtyDisplay) qtyDisplay.textContent = '0';
        }
        updateSidebar();
      });
      row.appendChild(removeBtn);

      // Insert before the empty message (items go above)
      itemsContainer.insertBefore(row, emptyMsg.nextSibling);
    });

    // Totals
    var weightUnit = 'g';
    var displayWeight = totalWeight;
    if (totalWeight >= 1000) {
      displayWeight = (totalWeight / 1000).toFixed(1).replace('.0', '').replace('.', ',');
      weightUnit = 'kg';
    } else {
      displayWeight = Math.round(totalWeight);
    }
    totalWeightEl.textContent = displayWeight + weightUnit;
    totalPriceEl.textContent = formatMoney(totalOtp);
    otpTotalEl.textContent = formatMoney(totalOtp);
    aboTotalEl.textContent = formatMoney(totalAbo);

    // Mobile bar
    if (mobileBar) {
      mobileBar.style.display = '';
      var totalQty = 0;
      state.items.forEach(function (it) { totalQty += it.qty; });
      mobileCount.textContent = totalQty + (totalQty === 1 ? ' Produkt' : ' Produkte');
      mobilePrice.textContent = formatMoney(state.mode === 'abo' ? totalAbo : totalOtp);
    }

    updateCta();
  }

  function updateCta() {
    if (!ctaBtn || !ctaText) return;
    if (state.mode === 'abo') {
      ctaText.textContent = 'Abo starten & 10% sparen';
      ctaBtn.classList.add('kb-cta--abo');
    } else {
      ctaText.textContent = 'In den Warenkorb';
      ctaBtn.classList.remove('kb-cta--abo');
    }
  }

  // ── Helpers ──
  function findProduct(id) {
    for (var i = 0; i < products.length; i++) {
      if (products[i].id === id) return products[i];
    }
    return null;
  }

  function findItem(productId) {
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i].productId === productId) return state.items[i];
    }
    return null;
  }

  function removeItem(productId) {
    state.items = state.items.filter(function (it) { return it.productId !== productId; });
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme_money_format || '{{amount_with_comma_separator}}\u20AC');
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u20AC';
  }

  // Update a card price element (current + compare-at strikethrough) on variant switch
  function updateCardPrice(priceEl, variant) {
    if (!priceEl) return;
    var nowEl = priceEl.querySelector('[data-kb-price-now]');
    var wasEl = priceEl.querySelector('[data-kb-price-was]');
    if (nowEl) nowEl.textContent = formatMoney(variant.price);
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (wasEl) {
      if (onSale) {
        wasEl.textContent = formatMoney(variant.compare_at_price);
        wasEl.hidden = false;
      } else {
        wasEl.textContent = '';
        wasEl.hidden = true;
      }
    }
    priceEl.classList.toggle('kb-card__price--sale', !!onSale);
  }

  function simplifyFrequency(text) {
    var m;
    if ((m = text.match(/(\d+)\s*Wochen?/i))) return 'Lieferung alle ' + (parseInt(m[1], 10) * 7) + ' Tage';
    if (/Jede\s+Woche/i.test(text)) return 'Lieferung alle 7 Tage';
    if ((m = text.match(/(\d+)\s*Tage?/i))) return 'Lieferung alle ' + m[1] + ' Tage';
    if ((m = text.match(/(\d+)\s*Monate?/i))) return 'Lieferung alle ' + m[1] + ' Monate';
    if (/every\s+week/i.test(text)) return 'Lieferung alle 7 Tage';
    if ((m = text.match(/every\s+(\d+)\s+weeks?/i))) return 'Lieferung alle ' + (parseInt(m[1], 10) * 7) + ' Tage';
    return text.replace(/,\s*\d+\s*%\s*Rabatt/i, '').trim();
  }

  function showCtaFeedback(type, message) {
    var original = ctaText.textContent;
    ctaText.textContent = message;
    ctaBtn.classList.add('kb-cta--' + type);
    setTimeout(function () {
      ctaBtn.classList.remove('kb-cta--' + type);
      ctaText.textContent = original;
      ctaBtn.disabled = false;
    }, 1500);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        var bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(function (b) {
          if (cart.item_count > 0) b.removeAttribute('hidden');
        });
      })
      .catch(function () { /* silent */ });
  }
})();
